export const PROJECT_PATH = `${process.env.REACT_APP_PROJECT_URL}`;
export const TIMINGS_PATH = `${process.env.REACT_APP_TIMINGS_URL}`;
export const ADMIN_PATH = `${process.env.REACT_APP_ADMIN_SERVICE_URL}`;
export const NOTIFICATION_PATH = `${process.env.REACT_APP_NOTIFICATION_SERVICE_URL}notification`;
export const WORKFLOW_PATH = `${process.env.REACT_APP_WORKFLOW_URL}`;
export const EMPLOYEE_ONBOARDING_PATH = `${process.env.REACT_APP_EMPLOYEE_ONBOARDING_URL}employee-onboarding`;
export const EMPLOYEE_OFFBOARDING_PATH = `${process.env.REACT_APP_EMPLOYEE_ONBOARDING_URL}employee-offboarding`;
export const SKILLS_PATH = `${process.env.REACT_APP_SKILLS_URL}`;
export const MINIO_PATH = `${process.env.REACT_APP_MINIO_URL}`;
export const APPLICATION_PATH = `${process.env.REACT_APP_ADMIN_SERVICE_URL}/users`;
export const MOODLE_PATH = `${process.env.REACT_APP_ADMIN_SERVICE_URL}/moodle`;
